import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ApplicationState } from ".";

const sliceName = "popoverSlice";

export enum PopoverError {
	NO_MAP_FEATURES = "No map features",
}

interface IPopoverMessage {
	title: string;
	body: string;
}

const popoverErrorMessages = {
	[PopoverError.NO_MAP_FEATURES]: {
		title: "Can't see any map features?",
		body: "Try zooming in/out, panning the map or changing the layer selection.",
	},
};

// -----------------
// STATE - This defines the type of data maintained in this Redux slice.
export interface PopoverState {
	message?: IPopoverMessage;
}

const initialState: PopoverState = {
	message: undefined,
};

const slice = createSlice({
	name: sliceName,
	initialState,
	reducers: {
		show: (state, { payload }: PayloadAction<PopoverError>) => {
			state.message = popoverErrorMessages[payload];
		},
		hide: (state) => {
			state.message = undefined;
		},
	},
});

// ----------------
// exports
export const selector = (state: ApplicationState): PopoverState => state.popoverState;
export const actions = {
	...slice.actions,
};
export const reducer = slice.reducer;
